import { render, staticRenderFns } from "./doctorChat.vue?vue&type=template&id=17de276c&scoped=true&"
import script from "./doctorChat.vue?vue&type=script&lang=js&"
export * from "./doctorChat.vue?vue&type=script&lang=js&"
import style0 from "./doctorChat.vue?vue&type=style&index=0&id=17de276c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17de276c",
  null
  
)

export default component.exports